import React from 'react';
import { Outlet } from 'react-router-dom';

const ProjectBoardParentPage = () => {
  return (
    <div className="project-board-parent">
      <Outlet />
    </div>
  );
};

export default ProjectBoardParentPage;
